import * as React from 'react';
import PropTypes from 'prop-types';
import { sendError } from '../errorUtils';


const style = {
    display: 'flex',
    background: 'white',
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'red',
};

class ErrorBoundary extends React.Component {
    state = {
        hasError: false,
    };

    componentDidCatch = (error, info) => {
        this.setState({ hasError: true });
        sendError({ error: error?.message, info: info?.componentStack, sender: `ErrorBoundary: ${this.props.id}` });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={style}>
                    <h3>Something went wrong. Refresh page to try again.. </h3>
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    id: PropTypes.string.isRequired,
};

ErrorBoundary.defaultProps = {
    children: null,
};

export default ErrorBoundary;
